import {createFileRoute} from '@tanstack/react-router';
import {ConnectedAccountRemoveCallbackPage} from 'pages/service/ConnectedAccountPage/ConnectedAccountRemoveCallbackPage';

export const Route = createFileRoute(
  '/_protected/connected-account/remove/callback',
)({
  component: ConnectedAccountRemoveCallbackPage,
  validateSearch: (search) => {
    return {
      status: search.status as string | undefined,
    };
  },
});
